// THIS FILE IS AUTOGENERATED. DO NOT EDIT MANUALLY.

import add_evens from './list_2_iterating/add-evens/problem.json';
import adjacent_vowels from './string_2/adjacent-vowels/problem.json';
import adjacent_vowels_mutation from './mutation/adjacent-vowels-mutation/problem.json';
import alarm_clock from './logic/alarm_clock/problem.json';
import alpha_order from './string_3/alpha-order-string/problem.json';
import answer_call from './logic/answer-call/problem.json';
import any_two_equal from './logic/any-two-equal/problem.json';
import approx_pi from './list_2_iterating/approx-pi/problem.json';
import assign_roll_numbers from './list_2_iterating/roll-numbers/problem.json';
import bball_stats from './list_2_iterating/basketball-stats/problem.json';
import biggerTwo from './list_1_indexing/bigger-two/problem.json';
import birthday_card_mixup from './haystack/birthday-card-mix-up/problem.json';
import bitflip_sort from './haystack/unflip-bits/problem.json';
import bitflip_sort_timestamped from './haystack/unflip-bits-harder/problem.json';
import boolean_xnor from './logic/boolean-xnor/problem.json';
import boolean_xor from './logic/boolean-xor/problem.json';
import calculate_absolute from './fundamentals/calculate-absolute/problem.json';
import camel_to_snake from './string_2/camel-to-snake/problem.json';
import censor_word from './string_2/censor-word/problem.json';
import check_id from './list_2_iterating/check-same-identification/problem.json';
import close_or_equal from './logic/close-or-equal/problem.json';
import concat_no_double from './string_1/concat-double-char/problem.json';
import consecutive_count_mutation from './mutation/consecutive-count-mutation/problem.json';
import contains_code_like from './string_2/contains-code-like/problem.json';
import contains_pi from './list_2_iterating/has-314/problem.json';
import count_pairs from './string_2/count-pairs/problem.json';
import count_peaks_mutation from './mutation/count-peaks-mutation/problem.json';
import countRepeat from './string_2/count-repeat/problem.json';
import count_vowels from './string_2/count-vowels/problem.json';
import count_vowels_mutation from './mutation/count-vowels-mutation/problem.json';
import dating_filter from './logic/dating-filter/problem.json';
import decimal_match from './fundamentals/decimal-match/problem.json';
import decode_artifact from './haystack/compass-array/problem.json';
import de_tuple from './list_2_iterating/de-tuple/problem.json';
import difference_21 from './fundamentals/difference_21/problem.json';
import difference_is_even from './fundamentals/difference_is_even/problem.json';
import double23 from './list_1_indexing/double-23/problem.json';
import double_letter from './string_2/double-letter/problem.json';
import double_nth from './string_1/double_n-th/problem.json';
import double_nth_char from './string_2/double-every-nth-char/problem.json';
import double_n_th_mutation from './mutation/double_n-th-mutation/problem.json';
import double_odd_mutation from './mutation/double-odd-mutation/problem.json';
import eat_outside from './logic/eat-outside/problem.json';
import elementArranger from './list_2_iterating/list-splitter/problem.json';
import ends_with_ly from './string_1/ly-ending/problem.json';
import even_list from './list_2_iterating/even-list/problem.json';
import every_other_repeated from './string_2/every-other-repeated/problem.json';
import exactly_one_true from './fundamentals/exactly_one_true/problem.json';
import exponential_list_check from './list_2_iterating/exponential_list_check/problem.json';
import extract_decimal from './fundamentals/extract-decimal/problem.json';
import fibolesserthan_mutation from './mutation/fibolesserthan-mutation/problem.json';
import final_grade from './list_2_iterating/grade-calculator/problem.json';
import find_jumps from './haystack/sensor-anomalies/problem.json';
import first_a_then_b_mutation from './mutation/first-a-then-b-mutation/problem.json';
import first_two from './string_1/first-two/problem.json';
import first_unique_char from './string_2/first-unique-character/problem.json';
import fix23 from './list_1_indexing/fix-23/problem.json';
import flatten_list from './list_3_complex_loop/flatten-list/problem.json';
import flatten_list_mutation from './mutation/flatten-list-mutation/problem.json';
import front_again from './string_1/front-again/problem.json';
import front_back_n from './string_1/first-last-n-chars/problem.json';
import grade_contribution from './fundamentals/grade-contribution/problem.json';
import grade_from_score from './fundamentals/grade_from_score/problem.json';
import greater_difference from './logic/greater-difference/problem.json';
import greater_than_double from './logic/greater-than-double/problem.json';
import half_string from './string_1/halve-string/problem.json';
import have_three_mutation from './mutation/have_three-mutation/problem.json';
import hello_greeting from './string_1/greeting/problem.json';
import html_bracket from './string_1/html-tagged/problem.json';
import in_order from './logic/in-order/problem.json';
import insertion_sort from './list_2_iterating/insertion-sort/problem.json';
import int_bool_equality from './logic/int-bool-equality/problem.json';
import integer_conversion_loss from './fundamentals/integer-conversion-loss/problem.json';
import intersecting_metro from './logic/intersecting-metro/problem.json';
import is_18 from './list_2_iterating/is-18/problem.json';
import is_between from './logic/float-in-between/problem.json';
import is_century_year from './logic/is-century-year/problem.json';
import is_even from './fundamentals/is-even/problem.json';
import is_even_length from './string_1/even-length/problem.json';
import is_exponential from './list_2_iterating/is-exponential/problem.json';
import is_half_digit from './string_1/half-digit/problem.json';
import is_multiple from './fundamentals/is-multiple/problem.json';
import is_phone_number from './string_1/validate-phone-number/problem.json';
import is_same from './list_2_iterating/same-value/problem.json';
import jelly_bean_duplicate_removal from './haystack/jellybean-naming-crisis/problem.json';
import largest_subsequence_mutation from './mutation/largest-subsequence-mutation/problem.json';
import largest_sum from './list_2_iterating/largest-subsequence/problem.json';
import list_equate from './list_2_iterating/list-equate/problem.json';
import list_match from './list_2_iterating/list-match/problem.json';
import list_max_min from './list_2_iterating/list-max-min/problem.json';
import list_splitter_mutation from './mutation/list-splitter-mutation/problem.json';
import lonely_twos from './list_2_iterating/lonely-twos/problem.json';
import longest_common_substring from './list_3_complex_loop/longest-common-substring/problem.json';
import longest_common_substring_mutation from './mutation/longest-common-substring-mutation/problem.json';
import lucky_13 from './list_2_iterating/lucky-13/problem.json';
import majority_wins from './logic/majority-wins/problem.json';
import make_abba from './string_1/make-abba/problem.json';
import make_combinations from './list_2_iterating/make-combinations/problem.json';
import make_combinations_mutation from './mutation/make-combinations-mutation/problem.json';
import make_ends from './list_1_indexing/make-ends/problem.json';
import make_fibonacci from './list_1_indexing/make-fibonacci/problem.json';
import makes_ten from './fundamentals/makes-ten/problem.json';
import make_tags from './string_1/make-tags/problem.json';
import matching_positions from './list_2_iterating/matching-positions/problem.json';
import maxOfThree from './list_1_indexing/max-of-three/problem.json';
import median_num from './list_2_iterating/median-num/problem.json';
import median_num_mutation from './mutation/median-num-mutation/problem.json';
import merge_sorted_lists from './haystack/merge_sorted_lists/problem.json';
import middle_characters from './string_2/middle-characters/problem.json';
import middle_characters_mutation from './mutation/middle-characters-mutation/problem.json';
import middle_two from './string_1/middle-chars/problem.json';
import middleTwo from './list_1_indexing/return-middle-two/problem.json';
import minutes_to_seconds from './fundamentals/minutes_to_seconds/problem.json';
import modulo_3 from './string_2/modulo-3/problem.json';
import modulo_3_mutation from './mutation/modulo-3-mutation/problem.json';
import most_frequent_vowel from './haystack/most_frequent_vowel/problem.json';
import museum_title_case from './haystack/title-case/problem.json';
import nbr_increasing_sequences from './list_2_iterating/number-increasing-sequences/problem.json';
import neighbouring_repeats_mutation from './mutation/neighbouring-repeats-mutation/problem.json';
import neighbour_repeat from './list_3_complex_loop/neighbouring-repeats/problem.json';
import number_increasing_sequences_mutation from './mutation/number-increasing-sequences-mutation/problem.json';
import number_is_palindrome from './fundamentals/number_is_palindrome/problem.json';
import ordered_insert from './list_2_iterating/ordered-insert/problem.json';
import palindrome_number from './logic/palindrome-number/problem.json';
import pattern_analysis from './haystack/pattern_analysis/problem.json';
import pig_latin from './string_2/pig-latin/problem.json';
import plusTwo from './list_1_indexing/plus-two/problem.json';
import power_of_two from './logic/power-of-two/problem.json';
import preceding_number25 from './list_2_iterating/preceding-number-25/problem.json';
import pull_primes from './list_2_iterating/pull-primes/problem.json';
import pyramid_problem_mutation from './mutation/pyramid-problem-mutation/problem.json';
import pyramid_volume from './logic/pyramid-problem/problem.json';
import range_chars from './string_2/range-chars/problem.json';
import range_chars_mutation from './mutation/range-chars-mutation/problem.json';
import relationship_two_four_mutation from './mutation/relationship-two-four-mutation/problem.json';
import remove_vowels from './string_2/remove-vowels/problem.json';
import remove_vowels_once from './string_2/remove-vowels-once/problem.json';
import remove_x_from_ends from './string_1/remove-x/problem.json';
import remove_x_from_start from './string_1/remove-x-from-start/problem.json';
import repeated_numbers from './fundamentals/repeat-numbers/problem.json';
import reverse_string from './string_2/reverse-string/problem.json';
import reverse_string_mutation from './mutation/reverse-string-mutation/problem.json';
import right2 from './string_1/right-two/problem.json';
import rotate_list from './list_2_iterating/rotate-list/problem.json';
import same_adjacent from './string_2/same-adjacent/problem.json';
import same_value_mutation from './mutation/same-value-mutation/problem.json';
import sandwich_word from './string_2/sandwich-word/problem.json';
import scroll_of_ever_changing_symbols from './haystack/enigmatic-scroll-of-ever-changing-symbols/problem.json';
import selection_sort from './list_2_iterating/selection-sort/problem.json';
import separate_types from './list_2_iterating/separate-types/problem.json';
import series from './list_2_iterating/make-series/problem.json';
import start1 from './list_1_indexing/start-one/problem.json';
import start_word from './string_1/fuzzy-first-char/problem.json';
import string_explosion from './string_2/string-explosion/problem.json';
import string_length_lists from './list_2_iterating/string-length-list/problem.json';
import strings_args from './list_2_iterating/filter-strings-a/problem.json';
import structure_check from './haystack/structure-integrity-compiler/problem.json';
import sum_7 from './list_2_iterating/sum_7/problem.json';
import sum_even_special from './list_2_iterating/sum-even-special/problem.json';
import sum_first_half from './list_2_iterating/sum-first-half/problem.json';
import sum_first_two from './list_1_indexing/sum-first-two/problem.json';
import sum_odd_n_even_index_mutation from './mutation/sum-odd-n-even-index-mutation/problem.json';
import sum_of_odd from './list_2_iterating/sum-of-odd-numbers/problem.json';
import swapEnds from './list_1_indexing/swap-ends/problem.json';
import take_smallest from './list_2_iterating/take-smallest/problem.json';
import temperature_convert from './fundamentals/temperature-convert/problem.json';
import testimony_match from './haystack/testimony-reporter/problem.json';
import the_end from './string_1/the_end/problem.json';
import Third_Largest from './list_2_iterating/third-largest/problem.json';
import third_largest_mutation from './mutation/third-largest-mutation/problem.json';
import triangle_area from './fundamentals/triangle-area/problem.json';
import two_as_one from './fundamentals/two-as-one/problem.json';
import two_char_at from './string_1/two-chars-at-index/problem.json';
import two_or_three from './logic/two-or-three/problem.json';
import unique_sum from './list_2_iterating/sum-of-elements/problem.json';
import upper_even_i from './list_2_iterating/upper-even/problem.json';
import upper_even_mutation from './mutation/upper-even-mutation/problem.json';
import vowel_capitalization_mutation from './mutation/vowel-capitalization-mutation/problem.json';
import vowel_finder from './list_2_iterating/vowel-finder/problem.json';
import without_end from './string_1/without-end/problem.json';
import zig_zag from './list_2_iterating/zig-zag/problem.json';

const problems = [
  add_evens,
  adjacent_vowels,
  adjacent_vowels_mutation,
  alarm_clock,
  alpha_order,
  answer_call,
  any_two_equal,
  approx_pi,
  assign_roll_numbers,
  bball_stats,
  biggerTwo,
  birthday_card_mixup,
  bitflip_sort,
  bitflip_sort_timestamped,
  boolean_xnor,
  boolean_xor,
  calculate_absolute,
  camel_to_snake,
  censor_word,
  check_id,
  close_or_equal,
  concat_no_double,
  consecutive_count_mutation,
  contains_code_like,
  contains_pi,
  count_pairs,
  count_peaks_mutation,
  countRepeat,
  count_vowels,
  count_vowels_mutation,
  dating_filter,
  decimal_match,
  decode_artifact,
  de_tuple,
  difference_21,
  difference_is_even,
  double23,
  double_letter,
  double_nth,
  double_nth_char,
  double_n_th_mutation,
  double_odd_mutation,
  eat_outside,
  elementArranger,
  ends_with_ly,
  even_list,
  every_other_repeated,
  exactly_one_true,
  exponential_list_check,
  extract_decimal,
  fibolesserthan_mutation,
  final_grade,
  find_jumps,
  first_a_then_b_mutation,
  first_two,
  first_unique_char,
  fix23,
  flatten_list,
  flatten_list_mutation,
  front_again,
  front_back_n,
  grade_contribution,
  grade_from_score,
  greater_difference,
  greater_than_double,
  half_string,
  have_three_mutation,
  hello_greeting,
  html_bracket,
  in_order,
  insertion_sort,
  int_bool_equality,
  integer_conversion_loss,
  intersecting_metro,
  is_18,
  is_between,
  is_century_year,
  is_even,
  is_even_length,
  is_exponential,
  is_half_digit,
  is_multiple,
  is_phone_number,
  is_same,
  jelly_bean_duplicate_removal,
  largest_subsequence_mutation,
  largest_sum,
  list_equate,
  list_match,
  list_max_min,
  list_splitter_mutation,
  lonely_twos,
  longest_common_substring,
  longest_common_substring_mutation,
  lucky_13,
  majority_wins,
  make_abba,
  make_combinations,
  make_combinations_mutation,
  make_ends,
  make_fibonacci,
  makes_ten,
  make_tags,
  matching_positions,
  maxOfThree,
  median_num,
  median_num_mutation,
  merge_sorted_lists,
  middle_characters,
  middle_characters_mutation,
  middle_two,
  middleTwo,
  minutes_to_seconds,
  modulo_3,
  modulo_3_mutation,
  most_frequent_vowel,
  museum_title_case,
  nbr_increasing_sequences,
  neighbouring_repeats_mutation,
  neighbour_repeat,
  number_increasing_sequences_mutation,
  number_is_palindrome,
  ordered_insert,
  palindrome_number,
  pattern_analysis,
  pig_latin,
  plusTwo,
  power_of_two,
  preceding_number25,
  pull_primes,
  pyramid_problem_mutation,
  pyramid_volume,
  range_chars,
  range_chars_mutation,
  relationship_two_four_mutation,
  remove_vowels,
  remove_vowels_once,
  remove_x_from_ends,
  remove_x_from_start,
  repeated_numbers,
  reverse_string,
  reverse_string_mutation,
  right2,
  rotate_list,
  same_adjacent,
  same_value_mutation,
  sandwich_word,
  scroll_of_ever_changing_symbols,
  selection_sort,
  separate_types,
  series,
  start1,
  start_word,
  string_explosion,
  string_length_lists,
  strings_args,
  structure_check,
  sum_7,
  sum_even_special,
  sum_first_half,
  sum_first_two,
  sum_odd_n_even_index_mutation,
  sum_of_odd,
  swapEnds,
  take_smallest,
  temperature_convert,
  testimony_match,
  the_end,
  Third_Largest,
  third_largest_mutation,
  triangle_area,
  two_as_one,
  two_char_at,
  two_or_three,
  unique_sum,
  upper_even_i,
  upper_even_mutation,
  vowel_capitalization_mutation,
  vowel_finder,
  without_end,
  zig_zag,
];

export default problems;
